var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaroLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 39,
    fill: "#F3F9FB",
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.444 56.283C49.8372 55.8897 50.0581 55.3564 50.0581 54.8003C50.0581 54.2441 49.8372 53.7108 49.444 53.3175L39.0624 42.9359L49.444 32.5543C49.826 32.1587 50.0374 31.629 50.0326 31.0791C50.0279 30.5292 49.8073 30.0031 49.4184 29.6143C49.0296 29.2254 48.5036 29.0049 47.9537 29.0001C47.4038 28.9953 46.874 29.2067 46.4784 29.5887L34.6141 41.4531C34.2209 41.8464 34 42.3798 34 42.9359C34 43.492 34.2209 44.0254 34.6141 44.4187L46.4784 56.283C46.8717 56.6762 47.4051 56.8971 47.9612 56.8971C48.5173 56.8971 49.0507 56.6762 49.444 56.283Z",
    fill: "#2ECC40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaroLeft);
export default __webpack_public_path__ + "static/media/caroLeft.8523968c48a018fe7474103755045af7.svg";
export { ForwardRef as ReactComponent };